var map = {
	"./android/DeviceSetup": 1330,
	"./androidtv/DeviceSetup": 1331,
	"./arris/DeviceSetup": 1332,
	"./hisense/DeviceSetup": 1333,
	"./lg/DeviceSetup": 1334,
	"./nagra/DeviceSetup": 1336,
	"./netrange/DeviceSetup": 1337,
	"./opera/DeviceSetup": 1338,
	"./polaroid/DeviceSetup": 1339,
	"./ps4/DeviceSetup": 1340,
	"./samsung/DeviceSetup": 1341,
	"./seirobotics/DeviceSetup": 1342,
	"./sony/DeviceSetup": 1343,
	"./stbcoship/DeviceSetup": 1344,
	"./stbcoship9108/DeviceSetup": 1345,
	"./stbhuawei/DeviceSetup": 1346,
	"./stbkaon/DeviceSetup": 1347,
	"./tizen/DeviceSetup": 1348,
	"./web0s/DeviceSetup": 1349,
	"./workstation/DeviceSetup": 1351,
	"./workstationChafari/DeviceSetup": 1352,
	"./zeasn/DeviceSetup": 1353,
	"./zte/DeviceSetup": 1354
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1329;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1329
// module chunks = 0